import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { OndemandSocketService } from 'src/app/services/ondemand-socket.service';

@Component({
  selector: 'app-steps-on-demand',
  templateUrl: './steps-on-demand.component.html',
  styleUrls: ['./steps-on-demand.component.css']
})
export class StepsOnDemandComponent implements OnInit {

  @Input() steps:any = {};
  @Input() showSuccessMessage: boolean;
  @Input() tiempoEspera: any = {};


  private intervalId: any; // Guarda el ID del intervalo para limpiarlo después
  public usuario: any;

  constructor(
    private scheduleService: ScheduleService,
        private cdRef: ChangeDetectorRef,
        private ondemandSocketService: OndemandSocketService,

    
  ) { }

    isLoading: boolean = true;

  


  ngOnInit(): void {
    this.usuario = new EncriptacionService().getUserInfo();
    //     console.log(this.usuario);
    // console.log(this.steps);

    
    if (this.usuario.typ_id == 2) {
      this.postListUsersWaitList();
 
      this.ondemandSocketService.onDoctorDisponible().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onDoctorNoDisponible().subscribe((data) => {
        // console.log('test 2', data);
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onDoctorFinalizaConsulta().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onActualizaFila().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
    }

    
  }

  ngOnDestroy(): void {
    // Limpia el intervalo cuando se destruya el componente
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  redondearTiempo(tiempo: number): string {
    const tiempoRedondeado = Math.round(tiempo);
  
    if (tiempoRedondeado > 60) {
      return '+60';
    }
  
    return `${Math.max(tiempoRedondeado, 5)}`;
  }
  

  postListUsersWaitList() {
    this.isLoading
    this.scheduleService.postListUsersWaitList(this.usuario._id, this.usuario.typ_id)
      .then((response: any) => {
        // console.log('Respuesta del servicio:', response);
        this.tiempoEspera = response;
        
        this.cdRef.detectChanges();
        this.isLoading = false;
      })
      .catch((error: any) => {
        console.error('Error al obtener la lista de espera:', error);
      });
}
 

}
